"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = onPlay;
function onPlay(event) {
  clearTimeout(this._bufferTimeout);
  if (this.logger.times.LoadTimeVideo > 0) {
    this.logger.times.LoadTimeVideo = performance.now() - this.logger.times.LoadTimeVideo;
    this.logger.logTime('LoadTime-Video', this.logger.times.LoadTimeVideo);
    if (this.playingIndex === 0) {
      var loadTime = this.logger.times.LoadTimeInit + this.logger.times.LoadTimeScript + this.logger.times.LoadTimeVideo;
      this.logger.logTime('LoadTime', loadTime);
      this.logger.times.LoadTimeInit = 0;
      this.logger.times.LoadTime = 0;
    }
    this.logger.times.LoadTimeVideo = 0;
  }

  // Record SeekTime when the video starts playing again
  if (this.logger.times.SeekTime > 0) {
    this.logger.logTime('SeekTime', performance.now() - this.logger.times.SeekTime);
    this.logger.times.SeekTime = 0;
  } else if (event.oldstate === 'buffering' && this.logger.times.BufferTime > 0) {
    this.logger.logTime('BufferTime', performance.now() - this.logger.times.BufferTime);
    this.logger.times.BufferTime = 0;
  }
  this._transitionToNextClip = false;
  this._emitTimeUpdate();
  if (this._playerState.autoplayNewPlayable) {
    this._playerState.autoplayNewPlayable = false;
    this.play();
    this.pause();
  } else {
    this.emit('play', event);
    this.emit('playing', event);
  }
}